import React from "react";
import { cn } from "@/utils/utils";

interface GradientCardContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const GradientCardContainer: React.FC<GradientCardContainerProps> = ({
  children,
  className
}) => {
  return (
    <div
      className={cn(
        "bg-surface-widget-card flex flex-col gap-4 p-2 items-start rounded-lg border-border-border1 border-[0.5px] shadow-[0px_12px_16px_-2px_rgba(12,17,29,0.24)]",
        className
      )}
      style={{
        background: `
          linear-gradient(198deg, rgba(255, 255, 255, 0.12) -54.24%, rgba(255, 255, 255, 0.04) 91.6%), var(--surface-widget-card, #161E2C)
        `
      }}
    >
      {children}
    </div>
  );
};
